// extracted by mini-css-extract-plugin
module.exports = {"BoTabs":"eh_a pz_a pz_x","BoTabs__tab":"eh_b pz_a pz_q pz_j pz_cx pz_ro pz_re pz_nv pz_oa pz_ob","BoTabs__tab--selected":"eh_c pz_cz pz_qt pz_fe"};